import { isLocale } from "@/lib/i18n"

/** `/ko/prompt/1` → `/ko`, `/cart` → `` */
export function getLocalePrefixFromPathname(pathname: string): string {
  const first = pathname.split("/").filter(Boolean)[0]
  if (first && isLocale(first)) {
    return `/${first}`
  }
  return ""
}

export function getPaymentReturnUrls(origin: string, pathname: string): { successUrl: string; failUrl: string } {
  const prefix = getLocalePrefixFromPathname(pathname)
  const base = origin.replace(/\/$/, "")
  return {
    successUrl: `${base}${prefix}/payment/success`,
    failUrl: `${base}${prefix}/payment/fail`,
  }
}
